<template>
    <a :href="'http://maps.google.com/maps?q=&layer=c&cbll=' + lat + ',' + long + '&cbp=11,0,0,0,0'"
       target="_blank" style="padding-right: 10px">
        <img src="/assets/img/street-view-pin.png" style="height: 30px">
    </a>
</template>

<script>
export default {
    name: "GoogleStreetViewButton",
    props: {
        lat: {
            required: true
        },
        long: {
            required: true
        }
    }
}
</script>

<style scoped>

</style>
